/* eslint-disable */
import React, { Fragment, Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { createTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import XLSX from 'xlsx';
import AssignmentReturnedIcon from "@material-ui/icons/AssignmentReturned";
// import ArrowCircleDownIcon from '@material-ui/core/ArrowCircleDown';
import moment from "moment-timezone";
import { KeyboardDatePicker } from '@material-ui/pickers';
import { TestRow } from './OnboardComponentStyling';
import { deletePartnerDocument, resetValues, updateDocument, getNationality } from '../../store/actions/editDealer.actions';
import { get } from 'lodash';
import { OnboardingAddOwnerPartnerValidation } from '../../constants/messages';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { MenuItem } from '@material-ui/core';
import DeleteDialog from '../../common/components/deleteDialog';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 750,
  },
  title: {
    flex: '1 1 100%',
  },
  buttonDel: {
    color: "#1A9FE0",
    fontSize: '0.625rem',
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    float: 'right'
  },
  buttonIconDel: {
    color: "#1A9FE0",
  },
  bodyContent: {
    color: '#666666',
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 600
  },
  createButton: {
    backgroundColor: '#1A9FE0',
    width: 140,
    fontWeight: 800,
    textTransform: 'inherit',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#FFFFFF',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 8
  },
  closeButton: {
    backgroundColor: '#EAEAEA',
    width: 140,
    fontWeight: 800,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.688rem',
    color: '#666666',
    borderRadius: '2.5rem',
    height: 35,
    textAlign: 'center',
    marginRight: 24
  },
  addUpdateDailogTitle: {
    position: "absolute",
    top: 10,
    left: 10
  },
}));

const theme = createTheme({
  palette: {
    secondary: {
      main: '#1A9FE0'
    },
  }
});

export default function AddNewOwnerPartnerDialog(props: any) {
  const [address, setAddress] = React.useState<any>([]);

  const [firstName, setFirstName] = React.useState<string>("");
  const [editId, setEditId] = React.useState<any>();
  const [adminFirstNameError, setAdminFirstNameError] = React.useState<boolean>(false);
  const [invalidAdminFirstName, setInvalidAdminFirstName] = React.useState<boolean>(false);
  const [deletedType, setDeletedType] = React.useState();

  const [lastName, setLastName] = React.useState<string>("");
  const [adminLastNameError, setAdminLastNameError] = React.useState<boolean>(false);
  const [invalidAdminLastName, setInvalidAdminLastName] = React.useState<boolean>(false);

  const [email, setEmail] = React.useState<string>("");
  const [invalidEmail, setInvalidEmail] = React.useState<boolean>(false);

  const [adminEmailError, setAdminEmailError] = React.useState<boolean>(false);

  const [nationality, setNationality] = React.useState('');
  const [adminNationalityError, setAdminNationalityError] = React.useState<boolean>(false);
  const [invalidAdminNationality, setInvalidAdminNationality] = React.useState<boolean>(false);
  const [documentType, setDocumentType] = React.useState<any>(null);

  const [mobile, setMobile] = React.useState<string>("");
  const [adminMobileError, setAdminMobileError] = React.useState<boolean>(false);
  const [invalidMobile, setInvalidMobile] = React.useState<boolean>(false);

  const [designation, setDesignation] = React.useState<string>("");
  const [adminDesignationError, setAdminDesignationError] = React.useState<boolean>(false);
  const [invalidAdminDesignation, setInvalidAdminDesignation] = React.useState<boolean>(false);

  const [emiratesIdNo, setEmiratesIdNo] = React.useState<string>("");
  const [adminEmiratesIdNoError, setAdminEmiratesIdNoError] = React.useState<boolean>(false);
  const [invalidAdminEmaritesIdNo, setInvalidAdminEmaritesIdNo] = React.useState<boolean>(false);

  const dispatch: Dispatch<any> = useDispatch();
  const [nameError, showError] = React.useState<boolean>(false);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);
  const [isValid, setIsValid] = React.useState<boolean>(true);

  const [signatureFile, setSignatureFile] = React.useState<any>(null);
  const [signatureCopy, setSignatureCopy] = React.useState<any>({ documentId: '' });

  const [passportExpiryDate, setPassportExpiryDate] = React.useState<any>(null);
  const [isValidPassportExpiryDate, setIsValidPassportExpiryDate] = React.useState<any>(true);
  const [passportFile, setPassportFile] = React.useState<any>(null);
  const [passportCopy, setPassportCopy] = React.useState<any>({ documentId: '', expiryDate: '' });

  const [emiratesIdExpiryDate, setEmiratesIdExpiryDate] = React.useState<any>(null);
  const [isValidEmiratesIdExpiryDate, setIsValidEmiratesIdExpiryDate] = React.useState<any>(true);
  const [emiratesIdFile, setEmiratesIdFile] = React.useState<any>(null);
  const [emiratesDcoumentId, setEmiratesDcoumentId] = React.useState<any>({ documentId: '', expiryDate: '' });

  const [successMessage, setSuccessMessage] = React.useState<any>(null);

  const [visaExpiryDate, setVisaExpiryDate] = React.useState<any>(null);
  const [isValidVisaExpiryDate, setIsValidVisaExpiryDate] = React.useState<any>(true);
  const [visaFile, setVisaFile] = React.useState<any>(null);
  const [visaCopy, setVisaCopy] = React.useState<any>({ documentId: '', expiryDate: '' });

  const { customerDetails, uploadedDocumentData, partnerDetails, savePartnerData, getNationalityData, deletePartnerDocumentData, editPartnerData, dealerDetails, deletePartnerData }: any = useSelector((state: any) => state.onboard);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const { setOpenDialog, setOwnerData, updateNewPartnerData, isView } = props;
  const { brandsList, selectedNewDealer }: any = useSelector((state: any) => state.dealer);
  const b2bUserId = get(selectedNewDealer, "createdByB2bUserId", "");
  const sapCustomerId = get(selectedNewDealer, "sapCustomerId", "");
  const isExistingUser = get(profileDetails, "data.data.basicInfo.isExistingUser", "");
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [isBackKey, setIsBackKey] = React.useState(false);
  const [customer, setCustomer] = React.useState<any>("")
  const [customerTierType, setCustomerTierType] = React.useState("")
  const userType = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.userType
  // const blockIntent = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.customerInfo && profileDetails.data.data.customerInfo.blockIntent;
  const sapCustomerIdAdmin = profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo.sapCustomerId ? profileDetails.data.data.basicInfo.sapCustomerId : '';
  const [isDisabledDatePicker, setIsDisabledDatePicker] = React.useState<boolean>(false);
  const [blockIntent, setBlockedIntent] = React.useState<any>(false);
  const { getDocumentExpiryStatusData }: any = useSelector((state: any) => state.profileDetails);
  const [reUploadedDocument, setReUploadedDocument] = React.useState<any>(false);
  const [dataUpdated, setDataUpdated] = React.useState<any>(false);

  function populatePartnerDetails() {
    if (partnerDetails && partnerDetails.data) {
      let selectedPartner = partnerDetails.data;
      setFirstName(selectedPartner.firstName);
      setLastName(selectedPartner.lastName);
      setNationality(selectedPartner.nationality);
      setEmail(selectedPartner.email);
      setMobile(selectedPartner.mobile);
      setDesignation(selectedPartner.designation);
      setEmiratesIdNo(selectedPartner.emiratesIdNumber);

      if (selectedPartner.signature && selectedPartner.signature.documentId) {
        const { id } = selectedPartner.signature.documentId;
        setSignatureFile(selectedPartner.signature.documentId)
        setSignatureCopy({ documentId: id });
      }
      if (selectedPartner && selectedPartner.passportCopy && selectedPartner.passportCopy.documentId) {
        const { expiryDate, id } = selectedPartner.passportCopy.documentId;
        const documentStatus = selectedPartner.passportCopy.documentStatus;
        setPassportExpiryDate(expiryDate);
        setPassportCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
        setPassportFile(selectedPartner.passportCopy.documentId);
      }
      if (selectedPartner && selectedPartner.emiratesDcoumentId && selectedPartner.emiratesDcoumentId) {
        const { expiryDate, id } = selectedPartner.emiratesDcoumentId;
        const documentStatus = selectedPartner.documentStatus;
        setEmiratesIdExpiryDate(expiryDate);
        setEmiratesDcoumentId({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
        setEmiratesIdFile(selectedPartner.emiratesDcoumentId);
      }
      if (selectedPartner && selectedPartner.visaCopy && selectedPartner.visaCopy.documentId) {
        const { expiryDate, id } = selectedPartner.visaCopy.documentId;
        const documentStatus = selectedPartner.visaCopy.documentStatus;
        setVisaExpiryDate(expiryDate)
        setVisaCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
        setVisaFile(selectedPartner.visaCopy.documentId);
      }
    }
  }

  const getPrevDocId = (type: any, index?: any) => {
    if (partnerDetails && partnerDetails.data) {
      let selectedPartner = partnerDetails.data;
      if (type === 'signature') {
        if (selectedPartner.signature && selectedPartner.signature.documentId) {
          const { id } = selectedPartner.signature.documentId;
          return id;
        }
      } else if (type === 'passportCopy') {
        if (selectedPartner && selectedPartner.passportCopy && selectedPartner.passportCopy.documentId) {
          const { id } = selectedPartner.passportCopy.documentId;
          return id;
        }
      } else if (type === 'emiratesDcoumentId') {
        if (selectedPartner && selectedPartner.emiratesDcoumentId && selectedPartner.emiratesDcoumentId) {
          const { id } = selectedPartner.emiratesDcoumentId;
          return id;
        }
      } else if (type === 'visaCopy') {
        if (selectedPartner && selectedPartner.visaCopy && selectedPartner.visaCopy.documentId) {
          const { id } = selectedPartner.visaCopy.documentId;
          return id;
        }
      }
    }
  }

  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  function isDisabled() {
    if (isView) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (dealerDetails && dealerDetails.data && dealerDetails.data.customerTierType) setCustomer(dealerDetails && dealerDetails.data && dealerDetails.data.customerTierType)
    setCustomerTierType(dealerDetails && dealerDetails.data && dealerDetails.data.isNewCustomer)
  }, [dealerDetails])

  useEffect(() => {
    if (nationality) {
      getNationalityData && getNationalityData.data && getNationalityData.data.length > 0 && getNationalityData.data[0].countries.map((r: any) => {
        if (r.Country === nationality) {
          setNationality(r);
        }
      })
    }
    if (nationality === 'AE') setVisaCopy({ documentId: '', expiryDate: '' })
  }, [nationality, getNationalityData])

  useEffect(() => {
    if (partnerDetails && partnerDetails.data) {
      populatePartnerDetails();
      // dispatch(getNationality());
      setEditId(partnerDetails.data.id)
    }
  }, [partnerDetails]); // eslint-disable-line

  useEffect(() => {
    if (getDocumentExpiryStatusData && getDocumentExpiryStatusData.data && getDocumentExpiryStatusData.data.data && (getDocumentExpiryStatusData.data.data.messages.length === 0 || getDocumentExpiryStatusData.data.data.messages.length > 0)) {
      setBlockedIntent(true);
    } else {
      setBlockedIntent(false);
    }
    // !isEmpty(getDocumentExpiryStatusData) && getDocumentExpiryStatusData && getDocumentExpiryStatusData.data && getDocumentExpiryStatusData.data.data && getDocumentExpiryStatusData.data.data.messages.length > 0 && getDocumentExpiryStatusData.data.data.messages.map((ele: any) => {
    //   setBlockedIntent(true);
    // })
  }, [getDocumentExpiryStatusData]);

  useEffect(() => {
    const item = uploadedDocumentData && uploadedDocumentData.data ? uploadedDocumentData.data : {};
    const { documentStatus, expiryDate, id, label } = item;
    if (label === 'passportFile') {
      setPassportExpiryDate(expiryDate);
      setPassportCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" });
      setPassportFile(item);
    }
    else if (label === 'visaCopyFile') {
      setVisaCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
      setVisaExpiryDate(expiryDate);
      setVisaFile(item);
    } else if (label === 'emiratesIdFile') {
      setEmiratesIdExpiryDate(expiryDate);
      setEmiratesDcoumentId({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" });
      setEmiratesIdFile(item);
    } else if (label === 'signatureFile') {
      setSignatureCopy({ documentId: id });
      setSignatureFile(item);
    }
  }, [uploadedDocumentData]); // eslint-disable-line

  useEffect(() => {
    if (deletePartnerDocumentData && deletePartnerDocumentData.data && deletePartnerDocumentData.data.message && deletePartnerDocumentData.data.message.status === 'S') {
      if (deletedType === 'passportCopy') {
        setPassportCopy({ documentId: '', expiryDate: '' });
      }
      if (deletedType === 'emiratesDcoumentId') {
        setEmiratesDcoumentId({ documentId: '', expiryDate: '' });
      }
      if (deletedType === 'visaCopy') {
        setVisaCopy({ documentId: '', expiryDate: '' });
      }
      if (deletedType === 'signature') {
        setSignatureCopy({ documentId: '' });
      }
    }
  }, [deletePartnerDocumentData])

  useEffect(() => {
    if ((savePartnerData && savePartnerData.data && savePartnerData.data.data || editPartnerData && editPartnerData.data && editPartnerData.data.data) || (deletePartnerData && deletePartnerData.data && deletePartnerData.data.data)) {
      resetData();
    }
  }, [savePartnerData, editPartnerData, deletePartnerData])

  const resetData = () => {
    // props.setOpenDialog();
    dispatch(resetValues());
    setFirstName("");
    setAdminFirstNameError(false);
    setInvalidAdminFirstName(false);

    setLastName("");
    setAdminLastNameError(false);
    setInvalidAdminLastName(false);

    setNationality("");
    setAdminNationalityError(false);

    setMobile("");
    setAdminMobileError(false);
    setInvalidMobile(false);

    setEmail("");
    setAdminEmailError(false);
    setInvalidEmail(false);

    setDesignation("");
    setAdminDesignationError(false);
    setInvalidAdminDesignation(false);

    setEmiratesIdNo("");
    setAdminEmiratesIdNoError(false);
    setInvalidAdminEmaritesIdNo(false);

    setSignatureFile(null);
    setPassportExpiryDate(null);
    setEmiratesIdExpiryDate(null);
    setPassportFile(null);
    setEmiratesIdFile(null);
    setIsValidPassportExpiryDate(null);
    setIsValidEmiratesIdExpiryDate(null);
    setVisaExpiryDate(null);
    setIsValidVisaExpiryDate(null);
    setVisaFile(null);
    setPassportCopy({ documentId: '', expiryDate: '' });
    setEmiratesDcoumentId({ documentId: '', expiryDate: '' });
    setVisaCopy({ documentId: '', expiryDate: '' });
    setSignatureCopy({ documentId: '' });
    setEditId(null);
  }

  const handleInputChange = (e: any, setterName: any, errorSetterName?: any, emiratesId?: any) => {
    if (emiratesId === 'emiratesId') {
      if (!isBackKey) {
        let value = e.target.value;
        value = value.replace(/[^0-9-]/g, '');

        let emiratesNo = '';

        if (value.length < 3) {
          emiratesNo = value;
        } else if (value.length == 3) {
          emiratesNo = value.slice(0, 3) + '-'
        } else if (value.length == 8) {
          emiratesNo = value.slice(0, 8) + '-'
        }
        else if (value.length == 16) {
          emiratesNo = value.slice(0, 16) + '-'
        } else {
          emiratesNo = value;
        }
        setterName(emiratesNo)
      }
    }
    else if (emiratesId === "mobileNo") {
      let value = e.target.value;
      value = value.replace(/[^0-9]/g, '');
      setterName(value)
      if (customer === "Int. Business" && validateMobile(value) === false) {
        setInvalidMobile(true);
      } else {
        setInvalidMobile(false);
      }
    }
    else {
      setterName(e.target.value);
    }
    if (errorSetterName && e.target.required) {
      if (e.target.value === "" || e.target.value.trim() === "")
        errorSetterName(true);
      else
        errorSetterName(false);
    }
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Backspace') {
      const value = event.target.value;
      const selectionStart = event.target.selectionStart;
      const selectionEnd = event.target.selectionEnd;
      if (selectionStart === selectionEnd && selectionStart > 0) {
        const beforeSelection = value.slice(0, selectionStart - 1);
        const afterSelection = value.slice(selectionStart);
        if (value.charAt(selectionStart - 1) === '-') {
          const value = beforeSelection + afterSelection;
          setEmiratesIdNo(value);
          setIsBackKey(true)
        } else {
          setIsBackKey(false)
        }
      }
    } else {
      setIsBackKey(false)
    }
  };

  // const deleteDocument = (type: any, data: any) => {
  //   setDeletedType(type);
  //   const obj = {
  //     "type": type
  //   }
  //   dispatch(deletePartnerDocument(partnerDetails && partnerDetails.data && partnerDetails.data.id, data.id, obj, sapCustomerId));
  // }

  const deleteDocument = async () => {
    let data: any;
    setDeletedType(documentType);
    if (documentType == 'signature') {
      data = signatureFile;
    } else if (documentType == 'passportCopy') {
      data = passportFile;
    } else if (documentType == 'visaCopy') {
      data = visaFile;
    } else if (documentType == 'emiratesDcoumentId') {
      data = emiratesIdFile;
    }
    const obj = {
      "type": documentType
    }
    if (userType === "Admin" && blockIntent === true) {
      if (documentType == 'signature') {
        setSignatureFile(null);
      } else if (documentType == 'passportCopy') {
        setPassportFile(null);
        setPassportExpiryDate(null);
      } else if (documentType == 'visaCopy') {
        setVisaFile(null);
        setVisaExpiryDate(null);
      } else if (documentType == 'emiratesDcoumentId') {
        setEmiratesIdFile(null);
        setEmiratesIdExpiryDate(null);
      }
      handleopenClose(false);
    } else {
      let deleteDocumentData: any = await dispatch(deletePartnerDocument(partnerDetails && partnerDetails.data && partnerDetails.data.id, data.id, obj, sapCustomerId));
      if (deleteDocumentData && deleteDocumentData.message) {
        if (documentType == 'signature') {
          setSignatureFile(null);
        } else if (documentType == 'passportCopy') {
          setPassportFile(null);
          setPassportExpiryDate(null);
        } else if (documentType == 'visaCopy') {
          setVisaFile(null);
          setVisaExpiryDate(null);
        } else if (documentType == 'emiratesDcoumentId') {
          setEmiratesIdFile(null);
          setEmiratesIdExpiryDate(null);
        }
      }
      handleopenClose(false);
    }
  }

  const createPartnerData = () => {
    const data = {
      sapCustomerId: sapCustomerId,
      createdByB2bUserId: b2bUserId,
      firstName: firstName,
      lastName: lastName,
      nationality: nationality,
      email: email,
      mobile: mobile,
      designation: designation,
      emiratesIdNumber: emiratesIdNo,
      signature: signatureCopy,
      passportCopy: passportCopy,
      emiratesDcoumentId: emiratesDcoumentId.documentId,
      emiratesIdexpiryDate: emiratesDcoumentId.expiryDate,
      visaCopy: visaCopy
    }
    setOwnerData(data);
  }


  const updatePartnerData = () => {
    const data = {
      sapCustomerId: userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true ? sapCustomerIdAdmin : sapCustomerId,
      createdByB2bUserId: b2bUserId,
      id: userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true ? sapCustomerIdAdmin : sapCustomerId,
      partnerId: partnerDetails && partnerDetails.data && partnerDetails.data.id,
      firstName: firstName,
      lastName: lastName,
      revisedDocument: userType === "Admin" && blockIntent === true ? true : false,
      reUpload: reUploadedDocument === true ? true : false,
      nationality: nationality,
      email: email,
      mobile: mobile,
      designation: designation,
      emiratesIdNumber: emiratesIdNo,
      signature: signatureCopy,
      passportCopy: passportCopy,
      emiratesDcoumentId: emiratesDcoumentId.documentId,
      emiratesIdexpiryDate: emiratesDcoumentId.expiryDate,
      visaCopy: visaCopy
    }
    setOpenDialog();
    updateNewPartnerData(data);
  }

  const handleopenClose = (open?: any) => {
    setOpenDeleteDialog(open ? true : false);
    setSuccessMessage(null);
  };

  function validateFormFields(action: string, value: any) {
    switch (action) {
      // case "nationality": {
      //   const re = /^[a-zA-Z0-9 ]{1,250}$/;
      //   return value.length > 250 || !re.test(value) ? false : true;
      // }
      case "lastName": {
        const re = /^[a-zA-Z0-9 ]{1,250}$/;
        return value.length > 250 || !re.test(value) ? false : true;
      }
      case "designation": {
        const re = /^[a-zA-Z0-9 ]{1,250}$/;
        return value.length > 250 || !re.test(value) ? false : true;

      }
      case "firstName": {
        const re = /^[a-zA-Z0-9 ]{1,250}$/;
        return !re.test(value) ? false : true;
      }
      default:
        return true

    }
  }

  const onChangeOfNationalitySelector = (e: any) => {
    setNationality(e.target.value);
    if (visaFile && visaFile.url) {
      setDocumentType('visaCopy');
      deleteDocument();
      setVisaFile(null);
      setVisaExpiryDate(null);
    }
    if (e.target.value === "" || e.target.value.trim() === "") {
      setAdminNationalityError(true);
    }
    else {
      setAdminNationalityError(false);
    }
  }

  function validateAddNewPartnerDialog() {
    let isValid: boolean = true;
    if (firstName.trim() === "") {
      setAdminFirstNameError(true);
      isValid = false;
      showErrorMessage("Please fill all mandatory fields and documents.");
      handleopenCloseErrorSnackbar(true);
    }
    if (firstName.trim() !== "") {
      if (firstName.split('').length > 250) {
        setInvalidAdminFirstName(true);
        isValid = false;
      }
      else if (!validateFormFields("firstName", firstName)) {
        setInvalidAdminFirstName(true);
        isValid = false;
      }
      else {
        setInvalidAdminFirstName(false);
      }
    }
    if (lastName.trim() === "") {
      showErrorMessage("Please fill all mandatory fields and documents.");
      setAdminLastNameError(true);
      isValid = false;
      handleopenCloseErrorSnackbar(true);
    }
    if (lastName.trim() !== "") {
      if (lastName.split('').length > 250) {
        setInvalidAdminLastName(true);
        isValid = false;
      }
      else if (!validateFormFields("lastName", lastName)) {
        setInvalidAdminLastName(true);
        isValid = false;
      }
      else {
        setInvalidAdminLastName(false);
      }
    }
    // if (nationality.trim() === "") {
    //   setAdminNationalityError(true);
    //   isValid = false;
    // }
    // if (nationality.trim() !== "") {
    //   if (nationality.split('').length > 250) {
    //     setInvalidAdminNationality(true);
    //     isValid = false;
    //   }
    //   else if (!validateFormFields("nationality", nationality)) {
    //     setInvalidAdminNationality(true);
    //     isValid = false;
    //   }
    //   else {
    //     setInvalidAdminNationality(false);
    //   }
    // }
    if (sessionStorage.getItem('customerOnboardingType') !== 'Workshop' && nationality == "" || nationality == undefined) {
      if (nationality == "" || nationality == undefined) {
        showErrorMessage("Please fill all mandatory fields and documents.");
        setAdminNationalityError(true);
        isValid = false;
        handleopenCloseErrorSnackbar(true);
      }
      else {
        // setInvalidAdminNationality(false);
        setAdminNationalityError(false);
      }
    }
    if (sessionStorage.getItem('customerOnboardingType') !== 'Workshop' && designation.trim() === "") {
      if (designation.trim() === "") {
        showErrorMessage("Please fill all mandatory fields and documents.");
        setAdminDesignationError(true);
        isValid = false;
        handleopenCloseErrorSnackbar(true);
      }
      if (designation.trim() !== "") {
        if (designation.split('').length > 250) {
          setInvalidAdminDesignation(true);
          isValid = false;
        }
        else if (!validateFormFields("designation", designation)) {
          setInvalidAdminDesignation(true);
          isValid = false;
        }
        else {
          setInvalidAdminDesignation(false);
        }
      }
    }
    if (mobile.trim() === "") {
      setAdminMobileError(true);
      showErrorMessage("Please fill all mandatory fields and documents.");
      handleopenCloseErrorSnackbar(true);
      isValid = false;
    }
    if (mobile.trim() !== "") {
      if (!validateMobile(mobile)) {
        isValid = false;
      }
      if (validateMobile(mobile) === false) {
        setInvalidMobile(true);
      }
      else {
        setInvalidMobile(false);
      }
    }
    if (customer === 'Dealer' || customer === 'dealer' || customer === 'workshop' || customer === 'Workshop' || customer === 'Fleet' || customer === 'fleet' || customer === 'tpcdealer') {
      if (emiratesIdNo.trim() === "") {
        setAdminEmiratesIdNoError(true);
        showErrorMessage("Please fill all mandatory fields and documents.");
        handleopenCloseErrorSnackbar(true)
        isValid = false;
        isValid = false;
      }
      if (emiratesIdNo.trim() !== "") {
        if (!validateEmaritesIdNO(emiratesIdNo)) {
          isValid = false;
          setInvalidAdminEmaritesIdNo(true);
        }
        else {
          setInvalidAdminEmaritesIdNo(false);
        }
      }
    }
    if (customer === 'Government') {
      if (emiratesIdNo && validateEmaritesIdNO(emiratesIdNo)) {
        if (emiratesDcoumentId.documentId.trim() === '') {
          isValid = false;
          showErrorMessage("Please fill all mandatory fields and documents.");
          handleopenCloseErrorSnackbar(true);
          handleopenClose(false);
        }
      } else if (emiratesDcoumentId && emiratesDcoumentId.documentId) {
        if (emiratesIdNo.trim() === "") {
          setAdminEmiratesIdNoError(true);
          showErrorMessage("Please fill all mandatory fields and documents.");
          handleopenCloseErrorSnackbar(true)
          isValid = false;
        }
        if (emiratesIdNo.trim() !== "") {
          if (!validateEmaritesIdNO(emiratesIdNo)) {
            isValid = false;
            setInvalidAdminEmaritesIdNo(true);
          }
          else {
            setInvalidAdminEmaritesIdNo(false);
          }
        }
      }
    }

    if (email.trim() === "") {
      setAdminEmailError(true);
      isValid = false;
      showErrorMessage("Please fill all mandatory fields and documents.");
      handleopenCloseErrorSnackbar(true);
    }
    if (email.trim() !== "") {
      if (!validateEmail(email)) {
        isValid = false;
      }
      if (validateEmail(email) === false) {
        setInvalidEmail(true);
      }
      else {
        setInvalidEmail(false);
      }
    }
    if (customer === 'Dealer' || customer === 'dealer' || customer === 'workshop' || customer === 'Workshop' || customer === 'Fleet' || customer === 'fleet' || customer === 'tpcdealer') {
      if (sessionStorage.getItem('customerOnboardingType') !== 'Workshop') {
        if (signatureCopy.documentId.trim() === '') {
          isValid = false;
          showErrorMessage("Please fill all mandatory fields and documents.");
          handleopenCloseErrorSnackbar(true);
          handleopenClose(false);
        }
        if (sessionStorage.getItem('customerOnboardingType') !== 'Workshop' && passportCopy.documentId.trim() === '') {
          isValid = false;
          showErrorMessage("Please fill all mandatory fields and documents.");
          handleopenCloseErrorSnackbar(true);
          handleopenClose(false);
        }
      }
      if (sessionStorage.getItem('customerOnboardingType') !== 'workshop' && sessionStorage.getItem('customerOnboardingType') !== "TBL Dealer") {
        if (nationality !== 'AE') {
          if (visaCopy.documentId.trim() === '') {
            isValid = false;
            showErrorMessage("Please fill all mandatory fields and documents.");
            handleopenCloseErrorSnackbar(true);
            handleopenClose(false);
          }
        }
      }
      if (emiratesDcoumentId.documentId.trim() === '') {
        isValid = false;
        showErrorMessage("Please fill all mandatory fields and documents.");
        handleopenCloseErrorSnackbar(true);
        handleopenClose(false);
      }
    }
    if (isValid) {
      if (partnerDetails && partnerDetails.data && partnerDetails.data.id) {
        updatePartnerData();
      }
      else {
        createPartnerData();
      }
    }
  }
  function validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validateMobile(number: string) {
    const re = customer === "Int. Business" ? /^\d{5,30}$/ : /^\d{10}$/;
    return re.test(number);
  }
  function validateEmaritesIdNO(number: string) {
    const re = /^\d{3}-\d{4}-\d{7}-\d{1}$/;
    return re.test(number);
  }

  const exportData = () => {
    // const specialOffersList = specialOffers && specialOffers.data ? specialOffers.data : [];
    // let dataSet: any = checkedExport.length > 0 ? [...checkedExport] : [...specialOffersList];
    let filename = 'SpecialOffers.xlsx';
    let data: any = [];
    // dataSet && dataSet.length > 0 && dataSet.map((item: any, index: any) => {
    data.push({
      // Name: item.name,
      // PartNumber: item.Part,
      // Description: item.description,
      // PartAfterPrice: item.Part_After_Price,
      // PartBeforePrice: item.Part_Before_Price
    });
    return undefined;
    // });
    var ws = XLSX.utils.json_to_sheet(data);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `SpecialOffers`);
    XLSX.writeFile(wb, filename);
  }

  function datePickerValid(e: any, state: any) {
    if (e === "Invalid Date Format") {
      state(false);
      // setSubmitDisabled(true);
    } else if (e === 'Date should not be before minimal date') {
      state(false);
      setIsDisabledDatePicker(true);
    } else if (e === 'Date should not be after maximal date') {
      state(false);
    } else {
      state(true);
    }
  }

  const onClickBrowseFile = async (type: any, item: any, setCallback: any, preId?: any) => {
    showErrorMessage(null);
    handleopenCloseErrorSnackbar(false);
    let size: any = 2000000;
    const name = item && item.name ? item.name : '',
      doctExtension = (name && name.substring(name.lastIndexOf('.') + 1, name.length)) || (name),
      doctExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'],
      signatureDocExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'],
      emiratesIdFileExtensions = ['jpg', 'jpeg', 'png', 'pdf'],

      canUploadFile = doctExtensions.indexOf(doctExtension.toLowerCase()) !== -1,
      canUploadSignatureFile = signatureDocExtensions.indexOf(doctExtension.toLowerCase()) !== -1;
    const canUploademiratesIdFile = emiratesIdFileExtensions.indexOf(doctExtension.toLowerCase()) !== -1;

    if (type === 'signatureFile' && !canUploadSignatureFile) {
      showErrorMessage('Invalid File type format');
      handleopenCloseErrorSnackbar(true);
      return;
    } else {
      if (!canUploadFile) {
        showErrorMessage('Invalid File type format');
        handleopenCloseErrorSnackbar(true);
        return;
      }
    }
    if (type === 'emiratesIdFile') {
      size = 5000000;
      if (!canUploademiratesIdFile) {
        showErrorMessage('Invalid File type format, please upload jpg, png or pdf');
        handleopenCloseErrorSnackbar(true);
        return;
      } else {
        if (!canUploadFile) {
          showErrorMessage('Invalid File type format');
          handleopenCloseErrorSnackbar(true);
          return;
        }
      }
    }
    if (item && item.size < size) {
      const canNotUploadWithoutDate = type === 'passportFile' || type === 'visaCopyFile' || type === 'emiratesIdFile';
      const formData: any = new FormData();
      let keyAttribute = `fieldname=${type}&docExtension=${doctExtension}`;
      let expiryDate: any = '';

      if (setCallback) setCallback(item);
      if (canNotUploadWithoutDate) {
        if (type === 'visaCopyFile') expiryDate = moment(visaExpiryDate).utc().format();
        else if (type === 'passportFile') expiryDate = moment(passportExpiryDate).utc().format();
        else if (type === 'emiratesIdFile') expiryDate = moment(emiratesIdExpiryDate).utc().format();
      }
      keyAttribute = `${keyAttribute}&expiryDate=${expiryDate}`;
      const customHeaders = {
        "Accept": "application/json",
        "Lob-Id": "AUTO",
        "Channel-Id": "B2B",
        "Org-Id": "",
        "Accept-Language": "EN",
      };
      let docType = '';
      if (type === 'visaCopyFile') { docType = 'Valid Visa Copy' }
      else if (type === 'passportFile') { docType = 'Valid Passport Copy' }
      else if (type === 'emiratesIdFile') { docType = 'Valid Emirates ID Copy' }
      else if (type === 'signatureFile') { docType = 'Signature File' }
      formData.append("entityName", "CUSTOMER");
      formData.append("keyAttribute", keyAttribute);
      formData.append("fileUpload", item);
      formData.append("document", 'true');
      formData.append("Attributes", `key=Brand&value=${item}`);
      formData.append("sapCustomerId", sapCustomerId ? sapCustomerId : '');
      formData.append("docType", docType);
      formData.append("label", type);
      formData.append("b2bUserId", b2bUserId ? b2bUserId : '');
      formData.append("uploadedByRole", 'dealerUser');
      formData.append("uploadedBywebApplicationLoginId", '');
      formData.append("selectedFileName", item.name);
      formData.append("previousDocumentId", preId);

      setLoading(true);
      let uploadedDocumentData: any = await dispatch(updateDocument(formData, customHeaders));
      if (uploadedDocumentData && uploadedDocumentData.message && uploadedDocumentData.message.status === 'S') {
        const item = uploadedDocumentData && uploadedDocumentData.data ? uploadedDocumentData.data : {};
        const { documentStatus, expiryDate, id, label } = item;
        setDataUpdated(true);
        if (userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
          && emiratesDcoumentId && emiratesDcoumentId.documentStatus === "Re Upload" ||
          userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
          && passportCopy && passportCopy.documentStatus === "Re Upload" ||
          userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
          && visaCopy && visaCopy.documentStatus === "Re Upload") {
          setReUploadedDocument(true);
        } else {
          setReUploadedDocument(false);
        }
        setDataUpdated(true);
        if (label === 'passportFile') {
          setPassportExpiryDate(expiryDate);
          setPassportCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" });
          setPassportFile(item);
        }
        else if (label === 'emiratesIdFile') {
          setEmiratesDcoumentId({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
          setEmiratesIdExpiryDate(expiryDate);
          setEmiratesIdFile(item);
        }
        else if (label === 'visaCopyFile') {
          setVisaCopy({ documentId: id, expiryDate: expiryDate, documentStatus: documentStatus ? documentStatus : "" })
          setVisaExpiryDate(expiryDate);
          setVisaFile(item);
        } else if (label === 'signatureFile') {
          setSignatureCopy({ documentId: id });
          setSignatureFile(item);
        }
        setLoading(false);
      } else {
        setLoading(false);
        showErrorMessage('Document upload failed');
        handleopenCloseErrorSnackbar(true);
        if (type === 'passportFile') {
          setPassportExpiryDate(null);
          setPassportCopy({ documentId: '', expiryDate: '' });
          setPassportFile(null);
        }
        else if (type === 'emiratesIdFile') {
          setEmiratesDcoumentId({ documentId: '', expiryDate: '' })
          setEmiratesIdExpiryDate(null);
          setEmiratesIdFile(null);
        } else if (type === 'visaCopyFile') {
          setVisaCopy({ documentId: '', expiryDate: '' })
          setVisaExpiryDate(null);
          setVisaFile(null);
        } else if (type === 'signatureFile') {
          setSignatureCopy({ documentId: '' });
          setSignatureFile(null);
        }
      }
    } else {
      showErrorMessage(`Please upload less than ${type === 'emiratesIdFile' ? '5' : '2'}MB file`);
      handleopenCloseErrorSnackbar(true);
      setDataUpdated(false);
    }
  }


  function isButtonEnabled(selectedDate: any) {
    const currentDate: any = new Date();
    moment(currentDate).utc().format();
    if (new Date(selectedDate).getTime() <= currentDate.getTime()) {
      return false;
    } else {
      const oneDay = 24 * 60 * 60 * 1000;
      const expiryDate: any = new Date(selectedDate);
      const diffDays = Math.round(Math.abs((expiryDate - currentDate) / oneDay));
      if (diffDays <= 15) {
        return false
      } else {
        return true
      }
    }
  }

  const classes = useStyles();

  return (
    <Fragment>
      <div className={classes.root}>
        <Snackbar
          open={openSnackbar}
          handleopenClose={() => {
            handleopenCloseSnackbar(false)
          }} message={successMessage} />
        <Snackbar
          open={openErrorSnackbar}
          type="error"
          handleopenClose={() => {
            handleopenCloseErrorSnackbar(false)
          }} message={errorMessage} />
        <>
          <Toolbar
            className={clsx(classes.root)}>
            <div className="col-12 mb-2 mt-2">
              <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                <h4 className="shift-to-party-page-title">
                  <div className={classes.addUpdateDailogTitle}>
                    {props.isEditOwnerPartnerOrg === undefined ?
                      isDisabled() ? 'View Owner/Partner' : (
                        <>
                          {(partnerDetails && partnerDetails.data && partnerDetails.data.id) || props.typeofDailog === 'edit' ? 'Update Owner/Partner' : props.typeofDailog === 'add' ? 'Add New Owner/Partner' : ''}
                        </>
                      )
                      : isDisabled() && props.isEditOwnerPartnerOrg === false ? 'View Owner/Partner' : (
                        <>
                          {(partnerDetails && partnerDetails.data && partnerDetails.data.id) || props.typeofDailog === 'edit' ? 'Update Owner/Partner' : props.typeofDailog === 'add' ? 'Add New Owner/Partner' : ''}
                        </>
                      )}
                  </div>
                  <IconButton aria-label="close" className="float-right" onClick={() => { setOpenDialog(); resetData() }}>
                    <CloseIcon />
                  </IconButton>
                </h4>
              </Typography>
            </div>
          </Toolbar>
          <Toolbar className="mb-2 mt-2">
            <TextField
              required
              id="firstName"
              disabled={isDisabled()}
              value={firstName}
              error={adminFirstNameError || invalidAdminFirstName}
              inputProps={{ maxLength: 250 }}
              helperText={invalidAdminFirstName &&
                <span style={{ color: 'red' }}> {OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_FIRST_NAME_TEXT}</span>
              }
              onChange={(e: any) => handleInputChange(e, setFirstName, setAdminFirstNameError)}
              size="small"
              className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
              label="First Name"
              variant="outlined"
            />
            <TextField
              required
              id="lastName"
              disabled={isDisabled()}
              value={lastName}
              inputProps={{ maxLength: 250 }}
              error={adminLastNameError || invalidAdminLastName}
              helperText={invalidAdminLastName &&
                <span style={{ color: 'red' }}>{OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_LAST_NAME_TEXT}</span>
              }
              onChange={(e: any) => handleInputChange(e, setLastName, setAdminLastNameError)}
              size="small"
              className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
              label="Last Name"
              variant="outlined"
            />
          </Toolbar>
          <Toolbar className="mb-2 nationality">
            {sessionStorage.getItem('customerOnboardingType') === 'Workshop' || customer.toLowerCase() === "workshop" ?
              <></> :
              <TextField
                required
                disabled={isDisabled()}
                select id="nationality"
                error={adminNationalityError}
                // helperText={invalidAdminNationality &&
                //   <span style={{ color: 'red' }}> {OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_LAST_NATIONALITY}</span>
                // }
                // onChange={(e: any) => handleInputChange(e, setNationality, setAdminNationalityError)}
                onChange={(e: any) => onChangeOfNationalitySelector(e)}
                value={nationality}
                size="small"
                className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
                label="Nationality"
                variant="outlined" >
                {getNationalityData && getNationalityData.data && getNationalityData.data.length > 0 && getNationalityData.data[0].countries.map((item: any) => (
                  <MenuItem key={item.Code} value={item.Code}>{item.Country} </MenuItem>))}
              </TextField>}
            <TextField
              required
              id="email"
              disabled={isDisabled()}
              value={email}
              error={adminEmailError || invalidEmail}
              helperText={invalidEmail &&
                <span style={{ color: 'red' }}>Please enter a valid email address.</span>
              }
              onChange={(e: any) => handleInputChange(e, setEmail, setAdminEmailError)}
              size="small"
              className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
              label="Email"
              variant="outlined"
            />
            {sessionStorage.getItem('customerOnboardingType') === 'Workshop' ?
              <TextField
                required={customer !== "Government" ? true : false}
                id="emiratesIdNo"
                error={customer !== "Government" ? adminEmiratesIdNoError || invalidAdminEmaritesIdNo : false}
                disabled={isDisabled()}
                placeholder={OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_EMARITESIDNO_TEXT}
                value={emiratesIdNo}
                helperText={invalidAdminEmaritesIdNo &&
                  <span style={{ color: 'red' }}>{OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_EMARITESIDNO_ERROR_TEXT}</span>
                }
                onChange={(e: any) => handleInputChange(e, setEmiratesIdNo, setAdminEmiratesIdNoError, 'emiratesId')}
                inputProps={{ maxLength: 18 }}
                size="small"
                onKeyDown={handleKeyDown}
                className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size mb-0 mt-2"
                label="Emirates ID No."
                variant="outlined"
              /> : ""}
          </Toolbar>
          <Toolbar className="mb-2">
            <TextField
              required
              id="mobile"
              disabled={isDisabled()}
              error={adminMobileError || invalidMobile}
              placeholder={customer === "Int. Business" ? OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_IB_CUSTOMER_MOBILE_TEXT : OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_MOBILE_TEXT}
              value={mobile}
              helperText={invalidMobile && <span style={{ color: 'red' }}> {customer === "Int. Business" ? "It can be upto 30 digits." : "It should be 10 digits."} </span>}
              onChange={(e: any) => handleInputChange(e, setMobile, setAdminMobileError, "mobileNo")}
              size="small"
              className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
              label="Mobile"
              variant="outlined"
            />
            {customer === 'workshop' || customer === 'Workshop' ?
              <TextField
                required={customer.toLowerCase() === "workshop" ? false : true}
                id="designation"
                // error={adminDesignationError || invalidAdminDesignation}
                disabled={isDisabled()}
                inputProps={{ maxLength: 250 }}
                helperText={invalidAdminDesignation &&
                  <span style={{ color: 'red' }}>{OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_LAST_DESIGNATION}</span>
                }
                onChange={(e: any) => handleInputChange(e, setDesignation)}
                value={designation}
                size="small"
                className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
                label="Designation"
                variant="outlined"
              />
              :
              <TextField
                required={customer.toLowerCase() === "workshop" ? false : true}
                id="designation"
                error={adminDesignationError || invalidAdminDesignation}
                disabled={isDisabled()}
                inputProps={{ maxLength: 250 }}
                helperText={invalidAdminDesignation &&
                  <span style={{ color: 'red' }}>{OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_LAST_DESIGNATION}</span>
                }
                onChange={(e: any) => handleInputChange(e, setDesignation, setAdminDesignationError)}
                value={designation}
                size="small"
                className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size"
                label="Designation"
                variant="outlined"
              />}
          </Toolbar>
          {sessionStorage.getItem('customerOnboardingType') === 'Workshop' || customer.toLowerCase() === "workshop" ?
            <></> :
            <Toolbar className="mb-2">
              <TextField
                required={sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? false : customer !== "Government" ? true : false}
                id="emiratesIdNo"
                error={sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? false : customer !== "Government" ? adminEmiratesIdNoError || invalidAdminEmaritesIdNo : false}
                disabled={isDisabled()}
                placeholder={OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_EMARITESIDNO_TEXT}
                value={emiratesIdNo}
                onKeyDown={handleKeyDown}
                helperText={sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? false : invalidAdminEmaritesIdNo &&
                  <span style={{ color: 'red' }}>{OnboardingAddOwnerPartnerValidation.OWNER_PARTNER_EMARITESIDNO_ERROR_TEXT}</span>
                }
                onChange={(e: any) => handleInputChange(e, setEmiratesIdNo, setAdminEmiratesIdNoError, 'emiratesId')}
                inputProps={{ maxLength: 18 }}
                size="small"
                className="col-lg-6 col-md-6 col-sm-6 pr-3 commonRoundedInputs common-input-font-size mb-0 mt-2"
                label="Emirates ID No."
                variant="outlined"
              />
              <div className="col-lg-3 col-md-3 col-sm-3 mt-2 mb-0">
                <h6 className="document-content">Signature{' '}{sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? "" : customer !== "Government" ? "*" : ""}</h6>
                <a href="./signatureexample.docx" download="signatureexample.docx">
                  <IconButton size="small" className="" onClick={() => exportData()}>
                    <AssignmentReturnedIcon className="download-icon mr-1" />
                    <span className="download-offer mr-2">
                      Download Template
                    </span>
                  </IconButton>
                </a>
              </div>
              <div className="col-md-3 col-lg-3 pr-2 px-2 mb-0 mt-2">
                {signatureFile !== null ?
                  <span className="file-name">
                    <span className="cursor-pointer" onClick={() => {
                      window.open(signatureFile.url)
                    }}>{signatureFile.name ? signatureFile.name : signatureFile.selectedFileName}</span>
                    <IconButton className="p-1" aria-label="delete"
                      disabled={isDisabled()}
                      onClick={(e) => {
                        // deleteDocument('signature', signatureFile);
                        // setSignatureFile(null);
                        setDocumentType('signature');
                        handleopenClose(true);
                        // dispatch(deleteDocument(signatureFile.id, signatureFile.sapCustomerId, true));
                      }}>
                      <CancelIcon className={isDisabled() ? 'file-close-color disabledCustomclass' : "file-close-color"} fontSize="small" />
                    </IconButton>
                  </span>
                  : <Button variant="contained"
                    disabled={isDisabled()}
                    component="label" color="secondary"
                    className="rounded-button-dealer float-right pr-2">
                    Browse File
                    <input type="file" hidden
                      onClick={(e: any) => {
                        const { target = {} } = e || {}
                        target.value = ""
                        setSignatureFile(null)
                        showErrorMessage('');
                        handleopenCloseErrorSnackbar(false);
                      }}
                      onChange={(e) =>
                        (e.target && e.target.files) ?
                          onClickBrowseFile('signatureFile', e.target.files[0], setSignatureFile, getPrevDocId('signature') ? getPrevDocId('signature') : '') : setSignatureFile(null)
                      } />
                  </Button>
                }
              </div>
            </Toolbar>}
          <div className="row m-0 p-0 border-bottom">
            <div className="col-12 mt-3 mb-3">
              <h6 className="info-sub-header-document px-3">Supported File Extension : .jpg, .jpeg, .png, .pdf, .doc, .docx, upto 2 MB can be uploaded.</h6>
            </div>
          </div>
          <TestRow>
            <div className="col-md-4 col-lg-4 pr-3 mb-1 mt-1">
              {customer === "Government" && !validateEmaritesIdNO(emiratesIdNo) || sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? <h6 className="document-content mt-1">Valid Emirates ID Copy {' '}</h6> : <h6 className="document-content mt-1">Valid Emirates ID Copy {' '}*</h6>}
              <small className="document-sub-content pb-3">Owner/Partner</small>
            </div>
            <div className="col-md-2 col-lg-2 pr-2 mb-2 pl-0 mt-1">
              {emiratesIdFile !== null ?
                <div className="file-name">
                  <span className="cursor-pointer" onClick={() => {
                    window.open(emiratesIdFile.url)
                  }}>{emiratesIdFile.name ? emiratesIdFile.name : emiratesIdFile.selectedFileName}</span>
                  <IconButton className="p-1 mt-2" aria-label="delete"
                    disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                      && emiratesDcoumentId && emiratesDcoumentId.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                        && isButtonEnabled(emiratesIdExpiryDate) === false
                      ? false : isDisabled()}
                    onClick={(e) => {
                      // setEmiratesIdFile(null); setEmiratesIdExpiryDate(null); deleteDocument('emiratesDcoumentId', emiratesIdFile);
                      setDocumentType('emiratesDcoumentId'); handleopenClose(true);
                      // dispatch(deleteDocument(emiratesIdFile.id, emiratesIdFile.sapCustomerId, true));
                    }}>
                    <CancelIcon className={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                      && emiratesDcoumentId && emiratesDcoumentId.documentStatus === "Re Upload" ? "file-close-color" : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                        && isButtonEnabled(emiratesIdExpiryDate) === false
                      ? "file-close-color" : isDisabled() ? 'file-close-color disabledCustomclass' : "file-close-color"} fontSize="small" />
                  </IconButton>
                </div>
                : <Button
                  variant="contained"
                  component={emiratesIdExpiryDate && isValidEmiratesIdExpiryDate ? "label" : "button"}
                  color="secondary"
                  className="rounded-button-dealer pl-4 pr-4 mt-2"
                  disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                    && emiratesDcoumentId && emiratesDcoumentId.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && emiratesIdExpiryDate !== null ? false : isDisabled() ? isDisabled() : !emiratesIdExpiryDate || isValidEmiratesIdExpiryDate === false}
                >
                  Browse File
                  <input type="file" hidden
                    onClick={(e: any) => {
                      const { target = {} } = e || {}
                      target.value = ""
                      setEmiratesIdFile(null)
                      showErrorMessage('');
                      handleopenCloseErrorSnackbar(false);
                    }}
                    onChange={(e) =>
                      (e.target && e.target.files) ?
                        onClickBrowseFile('emiratesIdFile', e.target.files[0], setEmiratesIdFile, getPrevDocId('emiratesDcoumentId') ? getPrevDocId('emiratesDcoumentId') : '') : setEmiratesIdFile(null)
                    } />
                </Button>
              }
            </div>
            <div className="col-md-6 col-lg-6 pr-2 mb-2 pl-0 mt-1 px-4">
              <KeyboardDatePicker
                views={["year", "month", "date"]}
                openTo="year"
                disablePast
                onError={(e, v) => datePickerValid(e, setIsValidEmiratesIdExpiryDate)}
                disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                  && emiratesDcoumentId && emiratesDcoumentId.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && emiratesIdFile === null ? false : isDisabled() ? isDisabled() : emiratesIdExpiryDate && emiratesIdFile ? true : false} autoOk size="small" disableToolbar variant="inline" inputVariant="outlined"
                format="dd/MM/yyyy" margin="normal" label="Expiry Date" value={emiratesIdExpiryDate}
                onChange={(date: Date | null) => { setEmiratesIdExpiryDate(date); !date && setEmiratesIdFile(null) }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                className={'pl-0 pr-4 mt-2 rounded-input-dealer cal-icon'}
              />
            </div>
          </TestRow>
          {sessionStorage.getItem('customerOnboardingType') === 'Workshop' || customer.toLowerCase() === "workshop" ?
            <></> :
            <TestRow>
              <div className="col-md-4 col-lg-4 pr-3 mb-2 mt-2">
                <h6 className="document-content">Valid Passport Copy{' '}{sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? "" : customer !== "Government" ? "*" : ""}</h6>
                <small className="document-sub-content pb-3">Owner/Partner</small>
              </div>
              <div className="col-md-2 col-lg-2 pr-2 mb-2 pl-0 mt-1">
                {passportFile !== null ?
                  <div className="file-name">
                    <span className="cursor-pointer" onClick={() => {
                      window.open(passportFile.url)
                    }}>{passportFile.name ? passportFile.name : passportFile.selectedFileName}</span>
                    <IconButton className="p-1 mt-2" aria-label="delete"
                      disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                        && passportCopy && passportCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                          && isButtonEnabled(passportExpiryDate) === false
                        ? false : isDisabled()}
                      onClick={(e) => {
                        // setPassportFile(null); setPassportExpiryDate(null); deleteDocument('passportCopy', passportFile);
                        setDocumentType('passportCopy');
                        handleopenClose(true);
                        // dispatch(deleteDocument(passportFile.id, passportFile.sapCustomerId, true));
                      }}>
                      <CancelIcon className={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                        && passportCopy && passportCopy.documentStatus === "Re Upload" ? "file-close-color" : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                          && isButtonEnabled(passportExpiryDate) === false
                        ? "file-close-color" : isDisabled() ? 'file-close-color disabledCustomclass' : "file-close-color"} fontSize="small" />
                    </IconButton>
                  </div>
                  : <Button
                    variant="contained"
                    component={passportExpiryDate && isValidPassportExpiryDate ? "label" : "button"}
                    color="secondary"
                    className="rounded-button-dealer pl-4 pr-4 mt-2"
                    disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                      && passportCopy && passportCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && passportExpiryDate !== null ? false : isDisabled() ? isDisabled() : !passportExpiryDate || isValidPassportExpiryDate === false}
                  >
                    Browse File
                    <input type="file" hidden
                      onClick={(e: any) => {
                        const { target = {} } = e || {}
                        target.value = ""
                        setPassportFile(null);
                        showErrorMessage('');
                        handleopenCloseErrorSnackbar(false);
                      }}
                      onChange={(e) =>
                        (e.target && e.target.files) ?
                          onClickBrowseFile('passportFile', e.target.files[0], setPassportFile, getPrevDocId('passportCopy') ? getPrevDocId('passportCopy') : '') : setPassportFile(null)
                      } />
                  </Button>
                }
              </div>
              <div className="col-md-6 col-lg-6 pr-2 mb-2 pl-0 mt-1 px-4">
                <KeyboardDatePicker
                  views={["year", "month", "date"]}
                  openTo="year"
                  disablePast
                  onError={(e, v) => datePickerValid(e, setIsValidPassportExpiryDate)}
                  disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                    && passportCopy && passportCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && passportFile === null ? false : isDisabled() ? isDisabled() : passportExpiryDate && passportFile ? true : false} autoOk size="small" disableToolbar variant="inline" inputVariant="outlined"
                  format="dd/MM/yyyy" margin="normal" label="Expiry Date" value={passportExpiryDate}
                  onChange={(date: Date | null) => { setPassportExpiryDate(date); !date && setPassportFile(null) }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  className={'pl-0 pr-4 mt-2 rounded-input-dealer cal-icon'}
                />
              </div>
            </TestRow>}
          {sessionStorage.getItem('customerOnboardingType') === 'Workshop' || customer.toLowerCase() === "workshop" ?
            <></> :
            <>
              {nationality === 'AE' ? '' : (
                <TestRow>
                  <div className="col-md-4 col-lg-4 pr-3 mb-2 mt-2">
                    <h6 className="document-content">Valid Visa Copy{' '}{sessionStorage.getItem('customerOnboardingType') === "TBL Dealer" ? "" : sessionStorage.getItem('customerOnboardingType') === "Int. Business" || sessionStorage.getItem('customerOnboardingType') === 'tpcdealer' ? "" : customer !== "Government" ? "*" : ""}</h6>
                    <small className="document-sub-content pb-3">Owner/Partner</small>
                  </div>
                  <div className="col-md-2 col-lg-2 pr-2 mb-2 pl-0 mt-1">
                    {visaFile !== null ?
                      <div className="file-name">
                        <span className="cursor-pointer" onClick={() => {
                          window.open(visaFile.url)
                        }}>{visaFile.name ? visaFile.name : visaFile.selectedFileName}</span>
                        <IconButton className="p-1 mt-2" aria-label="delete"
                          disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                            && visaCopy && visaCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                              && isButtonEnabled(visaExpiryDate) === false
                            ? false : isDisabled()}
                          onClick={(e) => {
                            setDocumentType('visaCopy');
                            handleopenClose(true);
                            // setVisaFile(null); setVisaExpiryDate(null); deleteDocument('visaCopy', visaFile);
                          }}>
                          <CancelIcon className={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                            && visaCopy && visaCopy.documentStatus === "Re Upload" ? "file-close-color" : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                              && isButtonEnabled(visaExpiryDate) === false
                            ? "file-close-color" : isDisabled() ? 'file-close-color disabledCustomclass' : "file-close-color"} fontSize="small" />
                        </IconButton>
                      </div>
                      : <Button
                        variant="contained"
                        component={visaExpiryDate && isValidVisaExpiryDate ? "label" : "button"}
                        color="secondary"
                        className="rounded-button-dealer pl-4 pr-4 mt-2"
                        disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                          && visaCopy && visaCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && visaExpiryDate !== null ? false : isDisabled() ? isDisabled() : !visaExpiryDate || isValidVisaExpiryDate === false}
                      >
                        Browse File
                        <input type="file" hidden
                          onClick={(e: any) => {
                            const { target = {} } = e || {}
                            target.value = ""
                            setVisaFile(null)
                            showErrorMessage('');
                            handleopenCloseErrorSnackbar(false);
                          }}
                          onChange={(e) =>
                            (e.target && e.target.files) ?
                              onClickBrowseFile('visaCopyFile', e.target.files[0], setVisaFile, getPrevDocId('visaCopy') ? getPrevDocId('visaCopy') : '') : setVisaFile(null)
                          } />
                      </Button>
                    }
                  </div>
                  <div className="col-md-6 col-lg-6 pr-2 mb-2 pl-0 mt-1 px-4">
                    <KeyboardDatePicker
                      views={["year", "month", "date"]}
                      openTo="year"
                      disablePast
                      onError={(e, v) => datePickerValid(e, setIsValidVisaExpiryDate)}
                      disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true
                        && visaCopy && visaCopy.documentStatus === "Re Upload" ? false : userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && visaFile === null ? false : isDisabled() ? isDisabled() : visaExpiryDate && visaFile ? true : false} autoOk size="small" disableToolbar variant="inline" inputVariant="outlined"
                      format="dd/MM/yyyy" margin="normal" label="Expiry Date" value={visaExpiryDate}
                      onChange={(date: Date | null) => { setVisaExpiryDate(date); !date && setVisaFile(null) }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      className={'pl-0 pr-4 mt-2 rounded-input-dealer cal-icon'}
                    />
                  </div>
                </TestRow>
              )}
            </>
          }
        </>
      </div>
      <DialogActions className="mt-3 mb-3 justify-content-end">
        {isDisabled() ? '' : (
          <Button variant="contained"
            color="secondary"
            className={`createFavourite ${loading
              ? "actionButtomButtomsBlue actionButtomButtomsBlueDisabled"
              : "actionButtomButtomsBlue "
              }`}
            disabled={loading}
            onClick={() => {
              validateAddNewPartnerDialog()
            }}
          >{editId ? 'Update' : 'Save'}
          </Button>
        )}
        {userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true ?
          <Button variant="contained"
            color="secondary"
            className={`createFavourite ${userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && dataUpdated === false ? "actionButtomButtomsBlue actionButtomButtomsBlueDisabled" : loading ? "actionButtomButtomsBlue actionButtomButtomsBlueDisabled" : "actionButtomButtomsBlue "
              }`}
            disabled={userType === "Admin" && blockIntent === true && props.isEditOwnerPartnerOrg === true && dataUpdated === false ? true : loading ? true : false}
            onClick={() => {
              validateAddNewPartnerDialog()
            }}
          >{editId ? 'Update' : 'Save'}
          </Button>
          : ""}
        <DeleteDialog
          open={openDeleteDialog}
          text="Are you sure you want to delete this document ?"
          handleopenClose={(data: any) => {
            if (data === 'delete') deleteDocument();
            if (!data) handleopenClose(false);
          }} />
        <Button variant="contained" className={classes.closeButton}
          onClick={() => { setOpenDialog(); resetData(); }}
        >Cancel</Button>
      </DialogActions>
    </Fragment>
  );
}